import cx from 'classnames';
import type { FC } from 'react';

interface Props {
  className?: string;
}

const LoadingDots: FC<Props> = ({ className }) => {
  const dots = Array.from({ length: 3 }, (_, index) => (
    <div key={index} className="w-2 h-2 bg-grey-light rounded-full inline-block animate-bounce" />
  ));

  const wrapperClassNames: string = cx('flex items-center space-x-1 text-center', className);

  return (
    <div className={wrapperClassNames} data-testid="loading-dots">
      {dots}
    </div>
  );
};

export default LoadingDots;
